module.exports = __webpack_public_path__ + "img/15days.06469035.jpeg";